<template>
  <div class="fill">
    <v-snackbar top right :value="showSnackbar"
      ><v-icon :color="snackbarColor">notifications_none</v-icon>
      <h4>{{ message }}</h4></v-snackbar
    >

    <!--map-->
    <riparian-map
      :collect-coordinates="collectCoordinates"
      @coordinates-collected="coordinatesCollected"
      @pog-from-click="pogFromClick"
      @pog-view="viewPOG"
      @show-message="showMessage"
      @toggle-pog="togglePOG = true"
    >
    </riparian-map>
    <div class="tac-overlay" v-show="onboard"></div>
    <div class="tac-content" v-show="onboard">
      <v-card elevation="10">
        <v-card-text>
          <div class="open-title">
            The Riparian Web Portal
          </div>
          <div class="open-description">
            View and summarize information related to the riparian
          </div>
          <v-divider></v-divider>
          <iframe
            class="doc-frame"
            :src="$store.state.settings.termsDocURL"
          ></iframe>
          <div class="text-lg-center">
            Please proceed if you have read and agree to the Privacy Policy &
            Terms of Use Statement
          </div>
          <div class="text-lg-center">
            <v-btn @click="agree">I agree</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <!--    projects on the ground-->
    <v-bottom-sheet
      v-model="togglePOG"
      :hide-overlay="collectCoordinates"
      :persistent="collectCoordinates"
    >
      <projects-on-the-ground
        :map-coordinates="clickedCoordinates"
        @close-pog="togglePOG = !togglePOG"
        @activate-map-click="activateMapClick"
        @show-message="showMessage"
      >
      </projects-on-the-ground>
    </v-bottom-sheet>

    <!--    projects on the ground viewer-->
    <v-bottom-sheet v-model="toggleViewPOG">
      <view-pog
        @close="toggleViewPOG = !toggleViewPOG"
        @show-message="showMessage"
        :pog-updated="toggleViewPOG"
        :pog="activePOG"
      ></view-pog>
    </v-bottom-sheet>
  </div>
</template>

<script>
import RiparianMap from "../components/map/RiparianMap";
import ProjectsOnTheGround from "../components/pog/ProjectsOnTheGround";
import ViewPOG from "@/components/pog/ViewPOG";

export default {
  name: "Riparian",

  components: {
    RiparianMap,
    ProjectsOnTheGround,
    "view-pog": ViewPOG,
  },

  data() {
    return {
      collectCoordinates: false,
      clickedCoordinates: { lat: null, lng: null },
      togglePOG: false,
      activePOG: {},
      toggleViewPOG: false,
      onboard: true,
      message: null,
      showSnackbar: false,
      snackbarColor: "white",
    };
  },

  computed: {
    authenticated() {
      return this.$store.state.settings.authenticated;
    },
    pogs() {
      return this.$store.state.map.pogs;
    },
  },

  watch: {
    authenticated(newVal) {
      if (newVal) this.$store.dispatch("map/getAllData");
      else {
        this.$store.commit("map/clearPrivateData");
        this.$store.dispatch("map/getPublicData");
      }
    },
  },

  methods: {
    agree() {
      this.onboard = false;
      localStorage.agreedToRiparianTAC = true;
    },
    showMessage(message, color) {
      this.message = message;
      this.showSnackbar = true;
      this.snackbarColor = color;
      setTimeout(() => (this.showSnackbar = false), 6000);
    },

    pogFromClick(coordinates) {
      this.clickedCoordinates.lat = coordinates.lat;
      this.clickedCoordinates.lng = coordinates.lng;
      this.togglePOG = true;
    },

    viewPOG(id) {
      this.activePOG = this.pogs.filter((pog) => {
        return `${pog.createdByUser} ${pog.id}` === id;
      })[0];
      this.toggleViewPOG = true;
    },

    coordinatesCollected(coordinates) {
      this.collectCoordinates = false;
      if (coordinates) {
        this.clickedCoordinates.lat = coordinates.lat;
        this.clickedCoordinates.lng = coordinates.lng;
      }
    },

    activateMapClick() {
      this.collectCoordinates = true;
      this.togglePOG = false;
      let self = this;
      let waitForCoordinates = function() {
        if (self.collectCoordinates) {
          setTimeout(() => {
            waitForCoordinates();
          }, 100);
        } else {
          self.togglePOG = true;
        }
      };
      waitForCoordinates();
    },
  },

  beforeMount() {
    if (localStorage.agreedToRiparianTAC) {
      this.onboard = false;
    }

    if (this.authenticated) this.$store.dispatch("map/getAllData");
    else this.$store.dispatch("map/getPublicData");
  },
};
</script>

<style scoped>
.login-button {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
}
.fill {
  padding: 0;
  position: relative;
  height: 100%;
  width: 100%;
}
.tac-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9998;
}
.tac-content {
  position: absolute;
  left: 0;
  right: 0;
  top: 50px;
  margin-left: auto;
  margin-right: auto;
  max-width: 500px;
  z-index: 9999;
  text-align: justify;
  text-align-last: center;
}
.doc-frame {
  margin: 0 auto;
  width: 100%;
  height: 350px;
}
.open-title {
  font-size: 20px;
  text-align: justify;
  text-align-last: center;
}
.open-description {
  font-size: 15px;
  text-align: justify;
  text-align-last: center;
}
</style>
